import { Action } from 'store/store';
import { FeatureTogglesState } from './FeatureTogglesState';

export enum FeatureToggleStateActionType {
    SET = 'FEATURE_TOGGLES_SET',
    TOGGLE = 'TOGGLE_FEATURE_TOGGLE',
}

export type SetFeatureTogglesAction = Action<
    FeatureToggleStateActionType.SET,
    FeatureTogglesState
>;

export const setFeatureToggles: (
    featureToggles: FeatureTogglesState
) => SetFeatureTogglesAction = (featureToggles) => ({
    type: FeatureToggleStateActionType.SET,
    payload: featureToggles,
});

export type ToggleFeatureToggleAction = Action<
    FeatureToggleStateActionType.TOGGLE,
    { feature: string }
>;

export const toggleFeatureToggle: (
    feature: string
) => ToggleFeatureToggleAction = (feature) => ({
    type: FeatureToggleStateActionType.TOGGLE,
    payload: { feature },
});

export type FeatureToggleStateAction =
    | SetFeatureTogglesAction
    | ToggleFeatureToggleAction;
